import { siteName } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/25 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>

      <div className="section-container relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full flex flex-col gap-6">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold whitespace-nowrap">
                <i className="ri-flashlight-line text-sm"></i>
                即点即看
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold whitespace-nowrap">
                <i className="ri-vip-crown-line text-sm"></i>
                永久免费
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold font-heading text-foreground-950 leading-tight tracking-tight">
              {siteName}
              <br />
              <span className="text-primary-500">高清秒播不等待</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 leading-relaxed max-w-xl">
              海量电视剧全集与电影大全一站式畅享。无论是最新热播剧、经典高分电影，还是热门综艺和精品动漫，棒棒TV为你提供<strong className="text-foreground-800">不缓冲、零等待</strong>的极致流畅体验。
            </p>
            <p className="text-base text-foreground-500 leading-relaxed max-w-xl">
              片库每日更新，热门剧集同步上线。2000+智能加速节点覆盖全国，4K HDR臻彩画质加持，让你的每一次播放都是享受。
            </p>

            <div className="flex flex-wrap items-center gap-6 text-sm">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-foreground-600">片库<strong className="text-foreground-800">20,000+</strong>部</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-user-smile-line text-accent-500"></i>
                <span className="text-foreground-600">月活<strong className="text-foreground-800">5,000万+</strong></span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-green-500"></i>
                <span className="text-foreground-600">纯净观影·零弹窗广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 pt-2">
              <a
                href="#carousel"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-play-circle-line text-xl"></i>
                立即观影
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold text-base rounded-lg border border-background-300 transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-download-2-line text-xl"></i>
                下载App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20scene%20with%20warm%20ambient%20glow%2C%20abstract%20flowing%20film%20strip%20ribbons%20in%20vibrant%20coral%20red%20and%20golden%20amber%20tones%2C%20soft%20bokeh%20particles%20floating%2C%20dark%20cinematic%20background%20with%20dramatic%20lighting%2C%20luxurious%20entertainment%20atmosphere%2C%20modern%20streaming%20platform%20visual%20identity&width=960&height=720&seq=hero-visual&orientation=landscape"
                alt="棒棒TV高清秒播观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center bg-primary-500/90 rounded-full backdrop-blur-sm">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </span>
                <div className="text-background-50 text-sm font-medium">棒棒TV · 即点即看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}